import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Moon, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/AuthContext";
import UserMenu from "@/components/UserMenu";

export default function NavBar({ extraLinks = [] }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const navItems = [
    { label: "The 27 Nakshatras", path: "/nakshatras", testId: "nav-gallery-btn" },
    { label: "Learn", path: "/learn", testId: "nav-learn-btn" },
    { label: "Premium", path: "/pricing", testId: "nav-pricing-btn" },
    { label: "Natal Calculator", path: "/calculator", testId: "nav-calculator-btn" },
    ...extraLinks,
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <img src="/logo.png" alt="Daily Nakshatra" className="h-8 w-auto" />
        </Link>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-3">
          {navItems.map((item) => (
            <Button key={item.path} variant="ghost" size="sm" className="text-white/60 hover:text-white hover:bg-white/5 text-xs tracking-wider uppercase" onClick={() => navigate(item.path)} data-testid={item.testId}>
              {item.label}
            </Button>
          ))}
          {user && (
            <Button variant="ghost" size="sm" className="text-amber-400/70 hover:text-amber-400 hover:bg-amber-400/10 text-xs tracking-wider uppercase" onClick={() => navigate("/daily-activation")} data-testid="nav-daily-activation-btn">
              <Moon className="w-3.5 h-3.5 mr-1.5" />Daily Chart
            </Button>
          )}
          <UserMenu />
        </div>

        {/* Mobile */}
        <div className="flex md:hidden items-center gap-2">
          <UserMenu />
          <button onClick={() => setMenuOpen(!menuOpen)} className="w-9 h-9 flex items-center justify-center rounded-lg text-white/60 hover:text-white hover:bg-white/10 transition-colors" data-testid="mobile-menu-btn">
            {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-white/8 bg-[#0A0A0A]/95 backdrop-blur-xl" data-testid="mobile-menu">
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <button key={item.path} onClick={() => { navigate(item.path); setMenuOpen(false); }} className="w-full text-left px-3 py-2.5 rounded-lg text-sm text-white/70 hover:text-white hover:bg-white/5 transition-colors font-[Manrope]" data-testid={`mobile-${item.testId}`}>
                {item.label}
              </button>
            ))}
            {user && (
              <button onClick={() => { navigate("/daily-activation"); setMenuOpen(false); }} className="w-full text-left px-3 py-2.5 rounded-lg text-sm text-amber-400/80 hover:text-amber-400 hover:bg-amber-400/10 transition-colors font-[Manrope]" data-testid="mobile-nav-daily">
                Daily Chart Activation
              </button>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
